import constants from './constants';

const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.actions.RECEIVE_USER:
      return {
        ...state,
        ...action.user,
      };
    default:
      return state;
  }
}
